module.exports = __webpack_public_path__ + "img/08c9d13.png";